'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSkuCategorySelectProminentSection.module.css';

export function DevlinkSkuCategorySelectProminentSection({ as: _Component = _Builtin.Section, categoryItems }) {
  return (
    <_Component
      className={_utils.cx(_styles, 'bg-n100')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'large-2')} tag="div" />
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-centered')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-contained-hero-content')} tag="div">
            <_Builtin.Block className={_utils.cx(_styles, 'ht-hero-content')} tag="div">
              <_Builtin.Heading className={_utils.cx(_styles, 'txt-title')} tag="h2">
                {'Expert installation and support for your connected devices'}
              </_Builtin.Heading>
              <_Builtin.Block className={_utils.cx(_styles, 'medium-1')} tag="div" />
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'ht-col-4-2-1')} tag="div">
          {categoryItems}
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, 'huge')} tag="div" />
      </_Builtin.Block>
    </_Component>
  );
}
